const PROJETS_CACHE_KEY = 'khayr_program_projets_v4';
const memoryProjetsBySlug = {};

export const readProgramProjetsCache = (slug) => {
  if (memoryProjetsBySlug[slug]) {
    return memoryProjetsBySlug[slug];
  }
  try {
    const raw = localStorage.getItem(PROJETS_CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const list = parsed?.[slug];
    if (Array.isArray(list) && list.length > 0) {
      memoryProjetsBySlug[slug] = list;
      return list;
    }
  } catch {
    // ignore
  }
  return null;
};

export const writeProgramProjetsCache = (slug, projets) => {
  if (!slug || !Array.isArray(projets)) return;
  memoryProjetsBySlug[slug] = projets;
  try {
    const raw = localStorage.getItem(PROJETS_CACHE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    parsed[slug] = projets;
    localStorage.setItem(PROJETS_CACHE_KEY, JSON.stringify(parsed));
  } catch {
    // ignore quota errors
  }
};

export const bootstrapProgramProjetsCache = () => {
  try {
    const raw = localStorage.getItem(PROJETS_CACHE_KEY);
    if (!raw) return;
    const parsed = JSON.parse(raw);
    Object.entries(parsed).forEach(([slug, list]) => {
      if (Array.isArray(list)) {
        memoryProjetsBySlug[slug] = list;
      }
    });
  } catch {
    // ignore
  }
};
